"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaults = void 0;
exports.defaults = {
    nameserviceTypeGroup: 9004,
    version: 2,
    nameserviceStaticFee: 50e8,
};
//# sourceMappingURL=defaults.js.map